export const PARTNER_LINK = "https://www.heilys.de/43973566";

// heilys hat das Partnerprogramm zum 31.07.2026 umgestellt.
// Es werden keine eigenen Konditionen kommuniziert – nur noch der Partnerlink.
export const PARTNER_PROGRAM_CHANGE_DATE = "2026-08-01";
